<template>
  <div>
    <div class="contact">
      <p class="contact__title">Is this information up to date?</p>
      <div class="contact__info">
        <label class="label">Phone number</label>
        <span class="info">{{ phoneNumber || '- -' }}</span>
      </div>
      <div class="contact__info">
        <label class="label">Email</label>
        <span class="info">{{ email || '- -' }}</span>
      </div>
    </div>
    <div class="note">
      <p class="note__title">Why is this important?</p>
      <span>This information will be used to prove you are the owner of the business
        so make sure you have access to these accounts.</span>
      <div v-if="!isManual">
        <br><br>
        <i class="fa-light fa-hand-point-up"></i>
        <span>If this information is not correct, please reach out to support
          via chat or email (support@kinside.com) for help.</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'contact-summary',
  props: {
    phoneNumber: String,
    email: String,
    isManual: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.contact {
  margin-top: 1.5rem;
  border-radius: var(--grid-unit);
  border: 1px solid #dbdbdb;
  padding: calc(var(--grid-unit) * 2);
  font-size: 16px;

  &__title {
    font-weight: 500;
    font-family: var(--sans-serif);
  }

  &__info {
    .label {
      display: block;
      margin-bottom: 5px;
      color: var(--gray-40);
    }
  }

  &__info:not(:last-child) {
    margin-bottom: 10px;
  }
}

.note {
  margin-top: 1.5rem;
  color: var(--gold-80);
  background-color: var(--gold-0);
  border: 1px solid var(--gold-50);
  border-radius: var(--grid-unit);
  padding: calc(var(--grid-unit) * 2);
  font-size: calc(var(--grid-unit) * 2);
  font-weight: 400;

  &__title {
    font-weight: 500;
    font-size: 16px;
    font-family: var(--sans-serif);
    color: var(--gold-80);
  }
}
</style>
